import * as React from 'react'
import { renderToString } from 'react-dom/server'

import { TributeComponentWrapper } from './TributeComponentWrapper'
import { TributeComponentParams } from './types'

/**
 * Re-builds the db html string value with full tribute components
 * @param value
 * @param getTributeComponent
 */
export const dbToHtml = (value: string, getTributeComponent: any) => {
	const component = new DOMParser().parseFromString(value, 'text/html')

	return getTributeComponent
		? replaceHtmlComponentsWithPlaceholder(value, getTributeComponentsFromHtml(component), getTributeComponent)
		: value
}

const replaceHtmlComponentsWithPlaceholder = (
	value: string,
	htmlTributeComponents: Element[],
	getTributeComponent: any
): string => {
	let parsedHtmlString: string = value
	// console.log("value from db", value)

	htmlTributeComponents.map((htmlComponent) => {
		const params = getComponentParams(htmlComponent)
		const Placeholder = getTributeComponent(params).Placeholder

		const wrappedComponent = Placeholder

		parsedHtmlString = replaceComponent(parsedHtmlString, htmlComponent.outerHTML, renderToString(wrappedComponent))
	})

	return parsedHtmlString
}

/**
 * Parses the value to trim off full tribute components and replace with lighter ones to save space in the db
 * @param value
 */
export const htmlToDb = (value: string) => {
	const component = new DOMParser().parseFromString(value, 'text/html')
	const fullTributeComponents = getTributeComponentsFromHtml ? getTributeComponentsFromHtml(component) : []

	return replaceFullHtmlComponentsWithDbHtmlComponents(value, fullTributeComponents)
}

export const parser = {
	dbToHtml,
	htmlToDb
}

export const getComponentParams = (component: Element): TributeComponentParams => {
	const domId = component.getAttribute('id') || ''
	const title = component.getAttribute('data-tribute-title') || ''
	const type = component.getAttribute('data-tribute-type') || ''
	const organization = component.getAttribute('data-tribute-organization') || ''
	const ppm = component.getAttribute('data-tribute-ppm') || ''
	const wbsComponent = component.getAttribute('data-tribute-wbscomponent') || ''
	const workItem = component.getAttribute('data-tribute-workitem') || ''

	return { domId, organization, ppm, title, type, wbsComponent, workItem }
}

const replaceFullHtmlComponentsWithDbHtmlComponents = (value: string, fullHtmlComponents: Element[]) => {
	let parsedValue: string = value

	// Find all ids

	fullHtmlComponents.map((fullHtmlComp) => {
		// get params
		const params = getComponentParams(fullHtmlComp)
		const amendedParams: TributeComponentParams = {
			...params,
			domId: `${params.domId}_${parseInt(Math.random().toString(8).substr(2, 9), 10)}`
		}

		const DbHtmlComponent = <TributeComponentWrapper {...amendedParams} />
		parsedValue = replaceComponent(parsedValue, fullHtmlComp.outerHTML, renderToString(DbHtmlComponent))
	})

	return parsedValue
}

const replaceComponent = (htmlString: string, searchComponent: string, replaceComponent: string) => {
	return htmlString.replace(searchComponent, replaceComponent)
}

export const getTributeComponentsFromHtml = (component: Element | Document): Element[] => {
	// Get the schedio-tribute-component
	const components = component.getElementsByClassName('schedio-tribute-component')

	const tributeComponents: Element[] = []
	Array.from(components).forEach((c: Element) => {
		tributeComponents.push(c)
	})
	return tributeComponents
}
